<template>
  <div class="privacy-policy">
    <h1>Personvernsvilkår</h1>

    <div class="iframe-container">
      <iframe
        src="https://docs.google.com/document/d/e/2PACX-1vRtXKdh_K6z7dGmr54dW1ZD7OC_-CdoeeGLMLYMTFX0gcectNXQUVBbUSKr9LGSmcuDkIRI0mb41Ulh/pub?embedded=true"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
};
</script>


<style lang="scss" scoped>
.iframe-container {
  overflow: hidden;
  padding-top: 216%;
  position: relative;
}

iframe {
  border: 0;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
</style>